// extracted by mini-css-extract-plugin
export default {"root":"IssuesListContainer_root__JqVrV","progressBarWrap":"IssuesListContainer_progressBarWrap__NLKDU"};